import React from "react";
import { Footer } from "./footer";
import { Header } from "./header";
import { grid as gridToken } from "../tokens";
import { Cookie } from "./cookie";
import "aos/dist/aos.css";
import "./reset.css";
import "./main.css";

interface LayoutProps {
  children?: any;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const grid = gridToken();

  let AOS: any;

  React.useEffect(() => {
    const AOS = require("aos");
    AOS.init({
      once: true,
    });
  }, []);

  React.useEffect(() => {
    if (AOS) {
      AOS.refresh();
    }
  });

  return (
    <>
      <Header />
      <main className={grid.positioner}>{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
